import React from "react";
import CategoryFiltersScreen from "./CategoryFiltersScreen";
import CollectionFiltersScreen from "./CollectionFiltersScreen";
import LicenseFiltersScreen from "./LicenseFiltersScreen";

type FilterContentProps = {
  activeNavigation: any;
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?:any
  activeFilters?:any
};

const FilterContent: React.FC<FilterContentProps> = ({
  activeNavigation,
  setProductList,
  productList,
  // handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
}) => {
  if (!activeNavigation) return null;

  switch (activeNavigation.text) {
    case "Categories":
      return (
        <CategoryFiltersScreen
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "Collections":
      return (
        <CollectionFiltersScreen
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "License":
      return (
        <LicenseFiltersScreen
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    default:
      return null;
  }
};

export default FilterContent;
